import { defineComponent, createElementBlock, openBlock, createCommentVNode, Fragment, renderList, createVNode, createBlock, createTextVNode, toDisplayString } from 'vue';
import _sfc_main$2 from './basler-components.es81.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es87.js';
/* empty css                       */

const _hoisted_1 = { class: "meta-list" };
const _hoisted_2 = {
  key: 0,
  class: "meta-list__inner"
};
const _hoisted_3 = {
  key: 1,
  class: "meta-list__inner"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MetaList",
  props: {
    items: {},
    isLoading: { type: Boolean, default: false },
    loadingLines: { default: 3 }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        _ctx.isLoading ? (openBlock(), createElementBlock("ul", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.loadingLines, (item, index) => {
            return openBlock(), createElementBlock("li", { key: index }, [
              createVNode(_sfc_main$1, { style: { "width": "100px" } })
            ]);
          }), 128))
        ])) : !_ctx.isLoading ? (openBlock(), createElementBlock("ul", _hoisted_3, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
            return openBlock(), createElementBlock("li", { key: index }, [
              item.iconName ? (openBlock(), createBlock(_sfc_main$2, {
                key: 0,
                name: item.iconName,
                class: "meta-list__icon"
              }, null, 8, ["name"])) : createCommentVNode("", true),
              createTextVNode(toDisplayString(item.text), 1)
            ]);
          }), 128))
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});

export { _sfc_main as default };
